import PropTypes from "prop-types"
import classnames from "classnames"
import { formatLongDate } from "helpers/formatters/dates"
import { getSortOrderUpdates } from "helpers/compositeSecurities"
import { DATE } from "helpers/shapes"
import DailyDetails from "./components/daily-details"
import ContributorsDetails from "modules/analyze-composite-risk-contributors"
import "./style.scss"

function AnalyzeCompositeRiskDetails({
  account,
  modelId,
  positionSetId,
  positionSetType,
  positionSetName,
  segment,
  base,
  baseSignature,
  classifications,
  expand,
  selectedDate,
  startDate,
  fetchStartDate,
  details,
  viewType,
  displayType,
  sortOrder,
  drift,
  openFactorProfile,
  openSecurityProfile,
  currentGrouping,
  setGrouping,
  showGroup,
  hideGroup,
  selectedGroup,
  selectedOption,
  setSortOrder,
  setGroupSortOrder,
  groupOrder,
  showNotHeld,
  selectedViews,
  showSegment,
  showContributorCategory,
  hideContributorCategory,
  selectedContributorCategory,
  selectedContributorValue,
}) {
  const handleSort = ({ by, current }) => {
    setSortOrder({
      ...current,
      ...getSortOrderUpdates({ by, current }),
    })
  }

  return <div className={classnames("modules_analyze-composite-risk-details", { "show-segment": showSegment })}>
    <h4 className="header">As of {formatLongDate(selectedDate)}</h4>
    {!selectedContributorCategory
      ? <DailyDetails {...{
          drift,
          viewType,
          openFactorProfile,
          displayType,
          factorTable: displayType !== "total" && displayType !== "factors",
          data: details,
          show: showContributorCategory,
          groupSort: (order) => setGroupSortOrder({ ...groupOrder, order }),
          groupOrder,
        }}
      />
      : <ContributorsDetails {...{
          account,
          modelId,
          positionSetId,
          positionSetType,
          positionSetName,
          segment,
          base,
          baseSignature,
          classifications,
          expand,
          selectedDate,
          startDate,
          fetchStartDate,
          viewType,
          selectedContributorCategory,
          selectedContributorValue,
          openSecurityProfile,
          openFactorProfile,
          showContributorCategory,
          hideContributorCategory,
          sort: handleSort,
          sortOrder,
          showGroup,
          hideGroup,
          selectedGroup,
          setGrouping,
          currentGrouping,
          selectedOption,
          showNotHeld,
          details,
          groupOrder,
          selectedViews,
          showSegment,
        }}
      />}
  </div>
}

AnalyzeCompositeRiskDetails.propTypes = {
  account: PropTypes.string.isRequired,
  modelId: PropTypes.string.isRequired,
  positionSetId: PropTypes.string.isRequired,
  positionSetType: PropTypes.string.isRequired,
  positionSetName: PropTypes.string.isRequired,
  base: PropTypes.object,
  baseSignature: PropTypes.string,
  classifications: PropTypes.array,
  allCategoryItems: PropTypes.array.isRequired,
  expand: PropTypes.bool.isRequired,
  selectedDate: DATE.isRequired,
  startDate: DATE.isRequired,
  fetchStartDate: DATE.isRequired,
  details: PropTypes.array.isRequired,
  viewType: PropTypes.string.isRequired,
  displayType: PropTypes.string.isRequired,
  selectedOption: PropTypes.object.isRequired,
  sortOrder: PropTypes.object.isRequired,
  openSecurityProfile: PropTypes.func.isRequired,
  openFactorProfile: PropTypes.func.isRequired,
  showContributorCategory: PropTypes.func.isRequired,
  hideContributorCategory: PropTypes.func.isRequired,
  selectedContributorCategory: PropTypes.object,
  selectedContributorValue: PropTypes.number.isRequired,
  drift: PropTypes.object.isRequired,
  currentGrouping: PropTypes.object,
  setGrouping: PropTypes.func.isRequired,
  showGroup: PropTypes.func.isRequired,
  hideGroup: PropTypes.func.isRequired,
  selectedGroup: PropTypes.object,
  filtersVisible: PropTypes.bool.isRequired,
  setSortOrder: PropTypes.func.isRequired,
  setGroupSortOrder: PropTypes.func.isRequired,
  groupOrder: PropTypes.object.isRequired,
  showNotHeld: PropTypes.bool.isRequired,
  selectedViews: PropTypes.array,
  segment: PropTypes.object,
  showSegment: PropTypes.bool,
  risk: PropTypes.array.isRequired,
}

export default AnalyzeCompositeRiskDetails
